import { MutationTree } from "vuex";
import { IApplicatifState } from "../models";

export const state: IApplicatifState = {
  variableEnvCleCourrielContact: "si_Adressedecourriel",
  variableEnvCleOptionCasierDisponible: "157420000",
  variableEnvCleDelaiVerrou: "si_DelaiVerrou",
  pilotageCleConditionsUtilisation: "CONDITIONS_UTILISATION_UL",
  pilotageCleModalitesLocation: "MODALITES_LOCATION",
  pilotageCleSiteSIAide: "SITE_SI_AIDE",
  messageErreurParDefaut:
    "Nous sommes désolés, une erreur est survenue qui empêche l'application de fonctionner." +
    " Veuillez revenir un peu plus tard ou contacter un responsable à l'aide des liens du pied de page.",
  messageErreur: "",
};

interface IMutations {
  modifierMessageErreur: (
    state: IApplicatifState,
    messageErreur: string
  ) => void;
}

export const mutations: IMutations & MutationTree<IApplicatifState> = {
  modifierMessageErreur: (state: IApplicatifState, messageErreur: string) => {
    state.messageErreur = messageErreur;
  },
};

export default {
  state,
  mutations,
};
